import { estDueDate } from 'components/organisms/projects/project-list/columns/renderer';

export const EstimatedDueDateRenderer = ({ value }) => {
  return estDueDate(value);
};
